import React from 'react';

import MenuBottom from './HeaderMenuBottom/HeaderMenuBottomNoData';
import MenuTop from './HeaderMenuTop/HeaderMenuTopNoData';

import '@src/css/bootstrap.scss';

import './header.scss';

const HeaderNoData = () => (
    <>
        <MenuTop />
        <MenuBottom />
    </>
);

export default React.memo(HeaderNoData);
